import React, {useCallback, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {
    addToPortfolio,
    getmultiPortfolio,
    getPerformanceSummaryData,
    getPerformanceSummaryShare,
    getPortfolioData,
} from "../../../apihelper/portfolio";
import {Button, Skeleton, TextField, Typography, useMediaQuery} from "@mui/material";
import TableCardHook from "../../account/profile/tables/TableCardHook";
import TableHook from "../../account/profile/tables/TableHook";

import json2mq from "json2mq";
import {getFetchdropdown} from "../../../apihelper/cryptocurrencylist";


export const PerformanceCompositionTable = (props = {}) => {
    const {selectedPortfolio, selectedPortfolioId, selectedTotalPortfolioValue} = props;

    const [portfolioid, setportfolioid] = useState("");

    const [portfolioName, setPortfolioName] = useState(selectedPortfolio);
    const [portfolioValue, setPortfolioValue] = useState(selectedTotalPortfolioValue);
    const mPortfolioName = selectedPortfolio;

    const [isLoginModalOpen, setLoginModalOpen] = useState(false);

    React.useEffect(() => {
        setPortfolioName(selectedPortfolio);
    }, [selectedPortfolio]);

    React.useEffect(() => {
        setPortfolioValue(selectedTotalPortfolioValue);
    }, [selectedTotalPortfolioValue]);

    React.useEffect(() => {
        setportfolioid(selectedPortfolioId);
    }, [selectedPortfolioId]);

    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [tableData, setTableData] = useState([]);
    const navigate = useNavigate();
    const [buySell, setbuySell] = React.useState("");
    const [selectedDate, handleDateChange] = useState("");
    const [slugdataNew, setSlugdataNew] = useState([]);
    const [index, setIndex] = useState(0);
    const [loader, setLoader] = useState(false);
    const [severity, setSeverity] = useState("info");
    const [open, setOpen] = React.useState(false);

    const [msgforUpdatePortfolio, setMsgforUpdatePortfolio] = useState("loading...");
    const [slugdata, setSlugdata] = useState([]);
    const handleClose = () => setOpen(false);
    const [initialPage, setInitialPage] = useState(false);
    const [snackbaropen, setSnackbaropen] = React.useState(false);
    const [slugpopupdataNew, setSlugpopupdataNew] = useState({
        slugname: "",
        slug: "",
        units: 0,
    });
    const [unit, setUnit] = useState("");
    const [price, setPrice] = useState("");
    const [user_role, setuser_role] = useState("");

    // const formatToNonZero = (number) => {
    //     number = parseFloat(number);

    //     if (number >= 1) {
    //         return number.toFixed(2);
    //     } else if (number >= 0.1) {
    //         return number.toFixed(1);
    //     } else if (number >= 0.01) {
    //         return number.toFixed(4);
    //     } else if (number >= 0.001) {
    //         return number.toFixed(5);
    //     } else if (number >= 0.0001) {
    //         return number.toFixed(6);
    //     } else if (number >= 0.00001) {
    //         return number.toFixed(7);
    //     } else if (number >= 0.000001) {
    //         return number.toFixed(8);
    //     } else if (number >= 0.0000001) {
    //         return number.toFixed(9);
    //     } else if (number >= 0.00000001) {
    //         return number.toFixed(10);
    //     } else if (number >= 0.000000001) {
    //         return number.toFixed(11);
    //     }
    //     return number.toFixed(1);
    // };

    useEffect(() => {
        setIndex(0);
        setLoader(false);

        if (!portfolioName) {
            return;
        }
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        getPerformanceSummaryShare({
            slug: "",
            portfolio_id: portfolioName,
            start_index: 0,
        }).then((res) => {
            if (res?.code === "200") {
                setSlugdata(res.data);
                setTableData(res.data);
                setuser_role(res.user_role);
                // setMy7DaysPortfolio;
                setLoader(true);
            }
        });
    }, [portfolioid]);

    const handleClick = (buySell) => {
        setSnackbaropen(true);
        setOpen(true);
        setSeverity("info");
        // setSnackbarcolor("success");
        // setSnackbarmessage("Data saved successfully");
        setMsgforUpdatePortfolio("loading...");
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        addToPortfolio({
            portfolio_type_id: portfolioid,
            existing_portfolio: "yes",
            user_id: userData.user_id,
            slug: slugpopupdataNew.slugname,
            unit: unit,
            acquisition_price: price,
            date_time: selectedDate,
            type: buySell,
            Token: userData.token,
        }).then((res) => {
            if (res.code === "200") {
                setOpen(false);
                setSeverity("info");
                setMsgforUpdatePortfolio(res.message);
                const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
                setLoader(false);

                setTimeout(() => {
                    getPerformanceSummaryData({
                        slug: "",
                        portfolio_type_id: portfolioid,
                        user_id: userData.user_id,
                        start_index: `${index}`,
                        limit: `${10}`,
                        Token: userData.token,
                    }).then((res) => {
                        if (res.code === "200") {
                            setSlugdata(res.data);
                            setuser_role(res.user_role);

                            if (res.data.length === 0) {
                                setInitialPage(true);
                            }

                            setLoader(true);
                        }
                    });

                    getPortfolioData({
                        slug: "",
                        user_id: userData.user_id,
                        portfolio_type_id: portfolioid,
                        start_index: 0,
                        Token: userData.token,
                    }).then((res) => {
                        if (res.code === "200") {
                            setSlugdataNew(res.data);
                            setuser_role(res.user_role);
                            setportfolioid(res.portfolio_id);
                        }
                    });
                }, 2000); // Delay of 1000ms (1 second)

                setUnit("");
                setbuySell("");
                setPrice("");
                handleDateChange("");
            } else {
                setSeverity("error");
                setMsgforUpdatePortfolio(res.message);
            }
        });
    };

    const fetchDropdownOptions = async () => {
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));

        getFetchdropdown({
            user_id: userData.user_id,

            Token: userData.token,
        }).then((res) => {
            if (res.code === "200") {
                setuser_role(res.user_role);
            } else {
                console.error("Data fething error");
            }
        });
    };

    const handleOpen = (idx) => {
        fetchDropdownOptions();
        setSlugpopupdataNew({
            slugname: slugdataNew[idx].slug,
            slug: slugdataNew[idx].name,
            units: slugdataNew[idx].total_unit,
            pricetoday: slugdataNew[idx].crypto_price,
            logo: slugdataNew[idx].logo,
            current_Wlt: slugdataNew[idx].current_wallet,
        });
        setOpen(true);
    };
    const numericPortfolioValue = Number(portfolioValue?.replace(/[^0-9.-]+/g, ""));

    const tabData = tableData.map((portfolio, index) => [
        <div className="table-col-1 d-flex gap-3" key={portfolio.coin_name}>
            <img src={`${portfolio["logo"]}`} className="crypto_icon" alt={portfolio["coin_name"]} />
            <span className="tab-text">{portfolio["slug"]}</span>
        </div>,
        `$${portfolio["price"]}`,
        !portfolio?.price || numericPortfolioValue <= 0
            ? "N/A"
            : `${(((Number(portfolio.price) * Number(portfolio.unit)) / numericPortfolioValue) * 100).toFixed(2)}%`,

        `${portfolio["sevend_change"]}`,
        `${portfolio["thirtyd_change"]}`,
        <div className="btn-2" key={portfolio.portfolio_name}>
            <button
                className={`btn rounded-pill shadow ${
                    portfolio.buy_percent1 === "Buy"
                        ? "btn-success"
                        : portfolio.buy_percent1 === "Hold"
                        ? "btn-warning"
                        : "btn-danger"
                }`}
            >
                {portfolio.buy_percent1}
            </button>
        </div>,
        <div className="btn-2 d-flex justify-content-center gap-2" key={portfolio.portfolio_name}>
            <button
                className={`rounded-pill btn-3`}
                onClick={() => console.log(`${index % 2 === 0 ? "Buy" : "Sell"} ${portfolio.slug}`)}
            >
                <img src="images/icons/add_icon.svg" style={{width:"30px", height:"30px"}}/>
            </button>
            <button
                className={`rounded-pill btn-3`}
                onClick={() => console.log(`${index % 2 === 0 ? "Buy" : "Sell"} ${portfolio.slug}`)}
            >
                <img src="images/icons/remove_icon.svg" style={{width:"27px", height:"27px"}}/>
            </button>
        </div>,
    ]);

    const tableHeader = [
        {label: "Crypto", key: "crypto", sorting: true},
        {label: "Price", key: "price", sorting: true},
        {label: "Composition", key: "composition", sorting: true},
        {label: "Last 7 Days", key: "sevend_change", sorting: true},
        {label: "Last 30 Days", key: "thirtyd_change", sorting: true},
        {label: "Outlook", key: "", sorting: false},
        {label: "", key: "", sorting: false},
    ];

    const [sorting, setSorting] = useState({key: "", order: ""});

    const mediaQueryVar = useMediaQuery(json2mq({minWidth: 900}));

    return (
        <div className="">
            <TableHook header={tableHeader} tableData={tabData} loading={loading} />

            {/* for mobile */}
            {tableData.map((portfolio, index) => (
                <TableCardHook
                    key={index}
                    header={{
                        name: portfolio.slug,
                        icon: `${portfolio["logo"]}`,
                        info_btn: "Memecoin",
                        right_align_text:
                            !portfolio?.price || numericPortfolioValue <= 0
                                ? "N/A"
                                : `(${(
                                      ((Number(portfolio.price) * Number(portfolio.unit)) / numericPortfolioValue) *
                                      100
                                  ).toFixed(1)}%)`,
                    }}
                    body={[
                        {key: "Price", value: `$${portfolio["price"]}`},

                        {key: "Last 7 Days", value: `${portfolio["sevend_change"]}`},
                        {key: "Last 30 Days", value: `${portfolio["thirtyd_change"]}`},
                        {
                            key: "Grade",
                            value: (
                                <p
                                    className={`rounded-pill shadow text-center text-white  ${
                                        portfolio.buy_percent1 === "Buy"
                                            ? "bg-success"
                                            : portfolio.buy_percent1 === "Hold"
                                            ? "bg-warning"
                                            : "bg-danger"
                                    }`}
                                >
                                    {portfolio.buy_percent1}
                                </p>
                            ),
                        },
                    ]}
                    footer={[
                        {
                            label: "Add More",
                        },
                        {
                            label: "Remove",
                        },
                    ]}
                />
            ))}
            {loading &&
                Array.from({length: 3}).map((_, index) => (
                    <TableCardHook
                        key={index}
                        header={{
                            name: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                            icon: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} width={40} />,
                        }}
                        body={[
                            {key: "Price", value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />},
                            {
                                key: "Last 7 Days",
                                value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                            },
                            {
                                key: "Last 30 Days",
                                value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                            },
                            {
                                key: "Last 30 Days",
                                value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                            },
                            {
                                key: "Last 30 Days",
                                value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                            },
                            {
                                key: "Last 30 Days",
                                value: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />,
                            },
                        ]}
                        footer={[{label: <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />}]}
                        loading={loading}
                    />
                ))}
            {user_role === "superuser" && (
                <>
                    <div style={{marginBottom: "10px", marginLeft: "-5px"}}>
                        <p style={{fontSize: "14px", fontWeight: "500"}}>Date</p>
                        <TextField
                            type="date"
                            value={selectedDate}
                            onChange={(e) => handleDateChange(e.target.value)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "10.384px",
                                    border: "1px solid #1877F2",
                                    boxShadow: "none",
                                    width: "200%",
                                    height: "45px",
                                },
                            }}
                        />
                    </div>
                    <div style={{marginBottom: "25px"}}>
                        <p className="card__container__row3__r2__text" style={{fontSize: "14px"}}>
                            Buy/Sell Price($)
                        </p>
                        <input
                            style={{
                                background: "#fff",
                                padding: "20px",
                                border: "1px solid #1877F2",
                                borderRadius: "10.384px",
                                width: "100%",
                                height: "45px",
                            }}
                            className="card__container__row3__r2__input"
                            min="1"
                            max="10"
                            type="number"
                            placeholder=""
                            value={price}
                            onChange={(e) => setPrice(e.target.value)}
                        ></input>
                    </div>
                </>
            )}
        </div>
    );
};
